export const BRAND_NAME = "JisedAI";
export const BRAND_LABEL = "Jisedai";
export const LEGAL_NAME = "Jisedai Foundry Africa Ltd";
export const LEGAL_LOCATION = "CPF House, Haile Selassie Avenue, 4th Floor, Nairobi - Kenya";

export const SOCIAL_PROFILES = [
  {
    name: "TikTok",
    handle: "@jisedaifa",
    url: "https://www.tiktok.com/@jisedaifa",
  },
  {
    name: "Instagram",
    handle: "@jised.ai",
    url: "https://www.instagram.com/jised.ai/",
  },
  {
    name: "YouTube",
    handle: "@Jisedaifa",
    url: "https://www.youtube.com/@Jisedaifa",
  },
  {
    name: "X",
    handle: "@JisedaiFA",
    url: "https://x.com/JisedaiFA",
  },
  {
    name: "LinkedIn",
    handle: "Jisedai Foundations",
    url: "https://www.linkedin.com/in/jisedai-foundations-0a34133bb",
  },
];
